module.exports = __webpack_public_path__ + "img/fig43.a426fb52.jpg";